import { FC } from 'react';
import './new-button.scss';
import '@app/index.scss';

export interface IButtonProps {
  children: React.ReactNode;
  variant?: 'black' | 'white' | 'outline' | 'outline-cancel';
  size?: 'big' | 'medium' | 'small';
  addClass?: string;
  noBorder?: boolean;
  icon?: React.ReactNode;
  onClick?: () => void;
  disable?: boolean;
}

export const NewButton: FC<IButtonProps> = ({
  children,
  variant = 'black',
  size = 'big',
  addClass = '',
  noBorder = false,
  icon,
  onClick = () => {},
  disable = false,
}) => {
  return (
    <button
      type="button"
      className={`new-button new-button--${variant} new-button--${size} ${addClass} ${
        noBorder ? 'new-button--no-border' : ''
      }${disable ? 'new-button--disable' : ''}`}
      onClick={onClick}
    >
      <div className="new-button__content">
        {children}
        {icon ? <div className="new-button__icon">{icon}</div> : null}
      </div>
    </button>
  );
};
